module.exports = __webpack_public_path__ + "img/northcote-hotel-&-michelin-star-restaurant-press-office.8234a4bf.jpg";